<div class="printing-create">
  <div class="printing-create__content">
    <div class="printing-create__layout">
      <div class="printing-create__header">
        <div class="printing-create__heading">
          <h1 class="page-title">Create Printing</h1>
          <p class="page-subtitle">Create the printing order first, then add attachments from the edit page.</p>
        </div>
        <div class="printing-create__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || form.invalid" (click)="save()"
            >{{ isSaving ? "Creating..." : "Create" }}</app-button
          >
        </div>
      </div>

      <app-card>
        <form [formGroup]="form" class="printing-create__form">
          <div class="printing-create__form-grid">
            <div class="printing-create__form-field">
              <label for="printing-pages-create-printingcreatepage-field-1" class="printing-create__form-label">Vendor</label>
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="vendorOptions"
                [minLength]="1"
                [debounceMs]="300"
                placeholder="Search printing vendor..."
                (searchChange)="searchVendors($event)"
                (selectionChange)="onVendorChange($event)"></app-autocomplete>
            </div>

            <div class="printing-create__form-field">
              <label for="printing-pages-create-printingcreatepage-field-2" class="printing-create__form-label">Warehouse</label>
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="warehouseOptions"
                [minLength]="1"
                [debounceMs]="300"
                placeholder="Search warehouse..."
                (searchChange)="searchWarehouses($event)"
                (selectionChange)="onWarehouseChange($event)"></app-autocomplete>
            </div>
          </div>

          <div class="printing-create__form-field">
            <label for="printing-pages-create-printingcreatepage-field-3" class="printing-create__form-label">Note</label>
            <app-rich-text-editor formControlName="note" placeholder="Write printing note..."></app-rich-text-editor>
          </div>
        </form>
      </app-card>

      <app-card>
        <div [formGroup]="form">
          <div class="printing-create__section-header">
            <h2 class="printing-create__section-title">Printing Items</h2>
            <app-button type="button" variant="secondary" (click)="addItem()" title="Add item" aria-label="Add item">
              <ng-glyph name="add" size="18"></ng-glyph>
            </app-button>
          </div>

          <div formArrayName="items" class="printing-create__items">
            @for (itemControl of items.controls; track $index) {
            <div [formGroupName]="$index" class="printing-create__item-row">
              <div class="printing-create__item-field">
                <label for="printing-pages-create-printingcreatepage-field-4" class="printing-create__form-label">Material</label>
                <app-autocomplete
                  [prefetchOnInit]="true"
                  [options]="materialOptions"
                  [minLength]="1"
                  [debounceMs]="300"
                  placeholder="Search material..."
                  (searchChange)="searchMaterials($event)"
                  (selectionChange)="onMaterialChange($index, $event)"></app-autocomplete>
              </div>

              <div class="printing-create__item-field">
                <label for="printing-pages-create-printingcreatepage-field-5" class="printing-create__form-label">Planned Qty</label>
                <input
                  type="number"
                  min="1"
                  appQtyInput
                  class="printing-create__form-input printing-create__item-qty-input"
                  formControlName="plannedQty" />
              </div>

              <div class="printing-create__item-action">
                <app-button
                  type="button"
                  variant="danger"
                  [disabled]="items.length <= 1"
                  (click)="removeItem($index)"
                  title="Remove item"
                  aria-label="Remove item">
                  <ng-glyph name="delete" size="18"></ng-glyph>
                </app-button>
              </div>
            </div>
            }
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>
